import React, { useEffect, useState } from 'react'
import className from 'classnames/bind'
import { useHistory } from 'react-router'

import style from './MyhouseMainHeader.module.scss'

import ArrowLeft10x18 from '@Ui/images/myhouse/ArrowLeft10x18.svg'
import { LAND_SERVICE_PREFIX_URL } from '@Root/contants/urlConstants'
import { handleNclick, handleNclickMix } from '@Helpers/nclick'
import { NCLICK } from '@Root/contants/lcs'
import useMainHeader from '@Hooks/main/useMainHeader'

const cx = className.bind(style)

type Props = {
  alarm: boolean
  setting: boolean
  currentHouseNo: number
}

const MyhouseMainHeader: React.FC<Props> = ({ alarm, setting, currentHouseNo }: Props) => {
  //변수선언부
  const history = useHistory()
  const { homeBackTarget } = useMainHeader()
  const [isScrollTop, setIsScrollTop] = useState(window.scrollY <= 5)
  const isShowButton = alarm || setting

  //함수정의부
  const handleSettingClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault()
    handleNclick(NCLICK.MY_HOUSE.GNB.SETTING, event)

    history.push(`${LAND_SERVICE_PREFIX_URL.MYHOUSE}/settings`)
  }

  const scrollListener = () => {
    setIsScrollTop(window.scrollY <= 5)
  }

  //useEffect
  useEffect(() => {
    window.addEventListener('scroll', scrollListener)
    return () => {
      window.removeEventListener('scroll', scrollListener)
    }
  }, [])

  return (
    <header className={cx('header', !isScrollTop && 'type_fixed')}>
      <div className={cx('inner')}>
        <h1 className={cx('title')}>우리집</h1>
        {homeBackTarget === 'pay' && (
          <a href={`${process.env.REACT_APP_NAVER_MYMONEY_URL}`} className={cx('link_back')} onClick={handleNclickMix(NCLICK.MY_HOUSE.GNB.MYASSET)}>
            <span className={cx('icon')}>
              <ArrowLeft10x18 />
            </span>
            내 자산
          </a>
        )}
        {homeBackTarget === 'land' && (
          <a href={`${process.env.REACT_APP_SPACE_WEB_URL}`} className={cx('link_back')} onClick={handleNclickMix(NCLICK.MY_HOUSE.GNB.REALESTATE)} rel="noreferrer">
            <span className={cx('icon')}>
              <ArrowLeft10x18 />
            </span>
            부동산
          </a>
        )}
        {homeBackTarget === 'pcland' && (
          <a href={`${process.env.REACT_APP_LAND_PC_WEB_URL}`} className={cx('link_back')} onClick={handleNclickMix(NCLICK.MY_HOUSE.GNB.REALESTATE)} rel="noreferrer">
            <span className={cx('icon')}>
              <ArrowLeft10x18 />
            </span>
            부동산
          </a>
        )}
        {isShowButton && (
          <div className={cx('button_area')}>
            {setting && (
              <a href={`${LAND_SERVICE_PREFIX_URL.MYHOUSE}/settings`} className={cx('link')} onClick={handleSettingClick}>
                설정
              </a>
            )}
          </div>
        )}
      </div>
    </header>
  )
}

export default MyhouseMainHeader
